module.exports = __webpack_public_path__ + "img/digital-asset.a76f4b08.jpg";